import { render, staticRenderFns } from "./ChainFeaturesCheckboxGroup.vue?vue&type=template&id=40e29dac"
import script from "./ChainFeaturesCheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./ChainFeaturesCheckboxGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports